module.exports = __webpack_public_path__ + "img/children-f4.01fbde11.png";